import { Link } from "gatsby"
import { XCircleIcon } from "@heroicons/react/outline"
import React, { useRef, useState } from "react"
import * as styles from "./demo-video-modal.module.css"

export default function DemoVideoModal(props) {
  const outerModal = useRef(null)
  const [exiting, setExiting] = useState(false)

  const close = () => {
    setExiting(true)
    setTimeout(() => {
      props.closeModal()
    }, 250)
  }

  return (
    <>
      <div
        ref={outerModal}
        className={`${styles.outer} ${
          exiting ? styles.exit : ""
        } fixed top-0 left-0 w-full h-full bg-black z-50 bg-opacity-50 overflow-hidden`}
        onClick={e => {
          if (e.target === outerModal.current) {
            close()
          }
        }}
      >
        {/* <style>{`body,body>*,body>*>*,body>*>*>*{overflow-y:hidden !important;}`}</style> */}
        <button
          className="absolute right-4 top-4 w-10 h-10 text-white"
          onClick={() => close()}
        >
          <XCircleIcon />
        </button>
        <div
          className={`${styles.inner} flex items-center justify-center absolute inset-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-lg w-full md:rounded-2xl md:w-3/4 h-5/6 min-h-96`}
        >
          <div className="text-center w-full px-4">
            <h1>
              <span className="mt-2 block text-4xl leading-tight font-extrabold tracking-tight text-gray-900 sm:text-5xl">
                Tour Video Coming Soon
              </span>
            </h1>
            <div className="mt-6">
              <p className="prose mx-auto prose-lg text-gray-500 mb-6">
                We're currently in the process of preparing an overview video
                with a tour of the product and a brief review of its features.
                In the meantime, feel free to reach out to get more information.
              </p>
              <Link
                to="/request-a-demo"
                className="transition-all inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-default-600 hover:bg-default-700 md:py-4 md:text-lg md:px-10"
              >
                Get More Info
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
